import Vue from 'vue'

export default function(ctx, inject) {
  const isContext = !!(ctx && inject)

  const setI18nLocale = (locale) => {
    if (isContext) {
      // Nuxt globally
      const _locale =
        ctx.app.i18n.availableLocales.find(
          (availableLocale) => availableLocale === locale
        ) || locale
      ctx.$storage.setUniversal('i18n', _locale)

      ctx.app.i18n.locale = _locale
    }
  }

  Vue.prototype.$setI18nLocale = setI18nLocale

  if (isContext) {
    ctx.$setI18nLocale = setI18nLocale
    inject('setI18nLocale', setI18nLocale)
  }
}
